import { Box, InlineBanner } from '@cad-arc';
import { ManageUnitsBanner } from '../use-manage-units-drawer-data';

export function BannersDisplay({ banners }: { banners: ManageUnitsBanner[] }): React.ReactElement {
    return banners.length ? (
        <Box paddingTop="10px">
            {banners.map((banner, idx) => {
                return (
                    <Box paddingTop="5px" key={idx}>
                        <InlineBanner
                            status={banner.status}
                            title={banner.title}
                            description={banner.description}
                        />
                    </Box>
                );
            })}
        </Box>
    ) : (
        <></>
    );
}
